<kendo-expansionpanel [disabled]="false"
                      [expanded]="true">
    <ng-template kendoExpansionPanelTitleDirective>
        <div class="header-content">
            {{isAddStop ? 'Add' : 'Edit' }} Stop Detail
            Load #{{searchOrderStop.legNumber}} - {{searchOrderStop.eventCode}}
        </div>
    </ng-template>
    <div class="row" *ngIf="(editedOrderStop | json) != '{}' && searchOrderStop">
        <div class="col-sm-8 p-1">
            <!-- Add/Edit Stop form -->
            <!--<h3>{{isAddStop ? 'Add' : 'Edit' }} Stop</h3>-->
            <div class="standard-card" *ngIf="pageType=='orderentry'&&editedOrderStop.customerId<=0&&editedOrderStop.cityId>0">
                <h3>Location</h3>
                <city-dropdown [parentForm]="customerFormGroup" [ctrlName]="'stopCityCtrl'" [placeholder]="'Enter a City'"
                               [isCityStateZip]="true" (citySelected)="onCityChange($event, 'stopCityCtrl')"
                               [isRequired]="editedOrderStop.customerId<=0" [isDisabled]="searchOrderStop.invoiceStatus=='Prepared'"
                               [defaultCity]="editedOrderStop.stopCityST">
                </city-dropdown>
            </div>
            <div class="standard-card">
                <h3>Customer</h3>
                <div class="row" *ngIf="pageType=='orderentry'&&searchOrderStop.invoiceStatus!='Prepared'&&searchOrderStop.loadStatus!='Completed'">
                    <div class="col-sm-10">
                        <customer-dropdown [parentForm]="customerFormGroup" [ctrlName]="'orderStopCustomerCtrl'" [placeholder]="'Enter Code'"
                                           [lookupType]="'all'" (customerSelected)="onCustomerChange($event, 'orderStopCustomerCtrl')"></customer-dropdown>
                    </div>
                    <div class="col-sm-2 p-0" *ngIf="searchOrderStop.invoiceStatus!='Prepared'">
                        <button (click)="addCustomer()" class="btn btn-sm btn-primary m-1" title="Add New" tabindex="-1"><i class="fas fa-plus"></i></button>
                        <button (click)="editCustomer()" class="btn btn-sm btn-success" title="Edit" tabindex="-1" *ngIf="editedOrderStop.customerId>0"><i class="fas fa-pencil-alt"></i></button>
                    </div>
                </div>
                <div class="row" *ngIf="(orderStopCustomer | json) != '{}' && orderStopCustomer.customerID >= 0">
                    <div class="col">
                        <a target="_blank" [routerLink]="['/customer-detail', orderStopCustomer.customerCode]" tabindex="-1">{{orderStopCustomer.customerName}}</a><br />
                        {{orderStopCustomer.address1}}<br />
                        {{orderStopCustomer.cityStateZip}}<br />
                        <i class="fas fa-globe"></i> {{orderStopCustomer.timeZoneName}}
                    </div>
                    <div class="col-sm-2">
                        <a [routerLink]="" (click)="showMapPoint(orderStopCustomer.latitude,orderStopCustomer.longitude)"
                           class="text-danger h2" title="Show on Map" tabindex="-1"
                           *ngIf="orderStopCustomer.latitude!=null&&orderStopCustomer.longitude!=null">
                            <i class="fas fa-map-marker-alt"></i>
                        </a>
                    </div>
                </div>
                <div class="row m-1" *ngIf="isAddOrderStopCustomer">
                    <div class="col border border-primary bg-light m-1 p-2">
                        <customer-quick-add [customerType]="'shipper'" [countryCode]="countryCode" (onRefreshCustomer)="refreshCustomers($event, 'orderStop')"></customer-quick-add>
                    </div>
                </div>
                <div class="row m-1" *ngIf="isEditOrderStopCustomer">
                    <div class="col border border-primary bg-light m-1 p-2">
                        <customer-quick-edit [customerID]="orderStopCustomer.customerID" [pageType]="'Order Stop Edit'" (onRefreshCustomer)="refreshCustomers($event, 'orderStop')"></customer-quick-edit>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <label class="fw-bold">Stop Event</label>
                        <select name="dropOrderEventTypeID"
                                [(ngModel)]="orderStopEventTypeID"
                                class="form-select"
                                (change)="orderStopEventTypeChange($event)"
                                [disabled]="isEventTypeDisabled()"
                                [ngClass]="orderStopEventTypeID > 0 ? '' : 'border-danger'"
                                required>
                            <option value="-1">- Select Stop Event -</option>
                            <option *ngFor="let eventType of filteredStopEventTypes" value="{{eventType.orderEventTypeID}}">{{eventType.code}}</option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <label class="fw-bold" [ngClass]="isOrderStopEarliestValid?'':'text-danger'">Earliest</label>
                        <br />
                        <kendo-datepicker name="orderStopEarliestDate" [(ngModel)]="orderStopEarliestDate"
                                          [format]="'MM/dd/yy'" [ngClass]="isOrderStopEarliestValid?'':'border-danger'"
                                          [ngModelOptions]="{standalone: true}" (valueChange)="dateChanged('earliest')"
                                          [disabled]="pageType!='orderentry'||searchOrderStop.invoiceStatus=='Prepared'||searchOrderStop.loadStatus=='Completed'" required>
                        </kendo-datepicker>
                        <!--<span *ngIf="!isOrderStopEarliestValid" class="fw-bold text-end text-danger"><i class="fas fa-times-circle"></i></span>-->
                        <br />
                        <kendo-timepicker name="orderStopEarliestTime" [(ngModel)]="orderStopEarliestDate"
                                          [format]="'HH:mm'" [ngClass]="isOrderStopEarliestValid?'':'border-danger'"
                                          [ngModelOptions]="{standalone: true}" (valueChange)="dateChanged('earliest')"
                                          [disabled]="pageType!='orderentry'||searchOrderStop.invoiceStatus=='Prepared'||searchOrderStop.loadStatus=='Completed'" required>
                        </kendo-timepicker>
                        <!--<span *ngIf="!isOrderStopEarliestValid" class="fw-bold text-end text-danger"><i class="fas fa-times-circle"></i></span>-->
                    </div>
                    <div class="col-sm-6">
                        <label class="fw-bold" [ngClass]="isOrderStopLatestValid?'':'text-danger'">Latest</label>
                        <br />
                        <kendo-datepicker name="orderStopLatestDate" [(ngModel)]="orderStopLatestDate"
                                          [format]="'MM/dd/yy'" [ngClass]="isOrderStopLatestValid?'':'border-danger'"
                                          [ngModelOptions]="{standalone: true}" (valueChange)="dateChanged('latest')"
                                          [disabled]="pageType!='orderentry'||searchOrderStop.invoiceStatus=='Prepared'||searchOrderStop.loadStatus=='Completed'" required>
                        </kendo-datepicker>
                        <!--<span *ngIf="!isOrderStopLatestValid" class="fw-bold text-end text-danger"><i class="fas fa-times-circle"></i></span>-->
                        <br />
                        <kendo-timepicker name="orderStopLatestTime" [(ngModel)]="orderStopLatestDate"
                                          [format]="'HH:mm'" [ngClass]="isOrderStopLatestValid?'':'border-danger'"
                                          [ngModelOptions]="{standalone: true}" (valueChange)="dateChanged('latest')"
                                          [disabled]="pageType!='orderentry'||searchOrderStop.invoiceStatus=='Prepared'||searchOrderStop.loadStatus=='Completed'" required>
                        </kendo-timepicker>
                        <!--<span *ngIf="!isOrderStopLatestValid" class="fw-bold text-end text-danger"><i class="fas fa-times-circle"></i></span>-->
                    </div>
                </div>
                <div class="row" *ngIf="pageType=='tracking' || pageType=='crossborder'">
                    <div class="col-sm-6">
                        <label class="fw-bold" [ngClass]="isOrderStopArrivalValid?'':'text-danger'">Arrival</label>
                        <br />
                        <kendo-datepicker name="orderStopArrivalDate" [(ngModel)]="orderStopArrivalDate"
                                          [format]="'MM/dd/yy'" [ngClass]="isOrderStopArrivalValid?'':'border-danger'"
                                          [ngModelOptions]="{standalone: true}" (valueChange)="dateChanged('arrival')"
                                          [disabled]="editedOrderStop.arrivedInd==true||searchOrderStop.invoiceStatus=='Prepared'||searchOrderStop.loadStatus=='Completed'" required>
                        </kendo-datepicker>
                        <!--<span *ngIf="!isOrderStopArrivalValid" class="fw-bold text-end text-danger"><i class="fas fa-times-circle"></i></span>-->
                        <br />
                        <kendo-timepicker name="orderStopArrivalTime" [(ngModel)]="orderStopArrivalDate"
                                          [format]="'HH:mm'" [ngClass]="isOrderStopArrivalValid?'':'border-danger'"
                                          [ngModelOptions]="{standalone: true}" (valueChange)="dateChanged('arrival')"
                                          [disabled]="editedOrderStop.arrivedInd==true||searchOrderStop.invoiceStatus=='Prepared'||searchOrderStop.loadStatus=='Completed'" required>
                        </kendo-timepicker>
                        <!--<span *ngIf="!isOrderStopArrivalValid" class="fw-bold text-end text-danger"><i class="fas fa-times-circle"></i></span>-->
                    </div>
                    <div class="col-sm-6">
                        <label class="fw-bold" [ngClass]="isOrderStopDepartValid?'':'text-danger'">Depart</label>
                        <br />
                        <kendo-datepicker name="orderStopDepartDate" [(ngModel)]="orderStopDepartDate"
                                          [format]="'MM/dd/yy'" [ngClass]="isOrderStopDepartValid?'':'border-danger'"
                                          [ngModelOptions]="{standalone: true}" (valueChange)="dateChanged('depart')"
                                          [disabled]="editedOrderStop.departedInd==true||searchOrderStop.invoiceStatus=='Prepared'||searchOrderStop.loadStatus=='Completed'" required>
                        </kendo-datepicker>
                        <!--<span *ngIf="!isOrderStopDepartValid" class="fw-bold text-end text-danger"><i class="fas fa-times-circle"></i></span>-->
                        <br />
                        <kendo-timepicker name="orderStopDepartTime" [(ngModel)]="orderStopDepartDate"
                                          [format]="'HH:mm'" [ngClass]="isOrderStopDepartValid?'':'border-danger'"
                                          [ngModelOptions]="{standalone: true}" (valueChange)="dateChanged('depart')"
                                          [disabled]="editedOrderStop.departedInd==true||searchOrderStop.invoiceStatus=='Prepared'||searchOrderStop.loadStatus=='Completed'" required>
                        </kendo-timepicker>
                        <!--<span *ngIf="!isOrderStopDepartValid" class="fw-bold text-end text-danger"><i class="fas fa-times-circle"></i></span>-->
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div><input type="checkbox" name="hasAppointment" style="transform:scale(1.5);margin:10px;" [(ngModel)]="editedOrderStop.hasAppointment" [disabled]="searchOrderStop.invoiceStatus=='Prepared'" /> <label for="hasAppointment">Has Appointment</label></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-4">
            <!--<div class="row">
            <div class="col">
                <label class="fw-bold">Commodity</label><br />
                {{commodities}}-->
            <!--<input type="text" class="form-control" [(ngModel)]="editedOrderStop.commodity!.commodityCode" />-->
            <!--</div>
            </div>-->
            <div class="row">
                <div class="col">
                    <label class="fw-bold">Commodity</label>
                    <select name="commodityTypeID" [(ngModel)]="freightDetail.commodityTypeID" class="form-select" [disabled]="searchOrderStop.invoiceStatus=='Prepared'">
                        <option value="-1">- Select Type -</option>
                        <option *ngFor="let commodityType of commodityTypes" value="{{commodityType.commodityTypeID}}">{{commodityType.name}}</option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <label class="fw-bold">Commodity Notes</label>
                    <textarea class="form-control" [(ngModel)]="freightDetail.commodityNotes" name="commodityNotes" [disabled]="searchOrderStop.invoiceStatus=='Prepared'"></textarea>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div><input type="checkbox" [(ngModel)]="editedOrderStop.confirmedFreight" [disabled]="searchOrderStop.invoiceStatus=='Prepared'" /> Confirmed</div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <label class="fw-bold">Pieces</label>
                    <div class="row">
                        <div class="col">
                            <kendo-numerictextbox [min]="0" [max]="1000000" [step]="1" [decimals]="0" [placeholder]="0" [(ngModel)]="editedOrderStop.pieces" (change)="checkPieces()" [disabled]="searchOrderStop.invoiceStatus=='Prepared'"></kendo-numerictextbox>
                        </div>
                        <div class="col">
                            <select class="form-select" [(ngModel)]="editedOrderStop.piecesUnitOfMeasureId" [disabled]="searchOrderStop.invoiceStatus=='Prepared'">
                                <option *ngFor="let unit of pieceUnits" value="{{unit.unitOfMeasureId}}">{{unit.code}}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <label class="fw-bold">Weight</label>
                    <div class="row">
                        <div class="col">
                            <kendo-numerictextbox [min]="0" [max]="1000000" [step]="1" [decimals]="0" [placeholder]="0" [(ngModel)]="editedOrderStop.weight" (change)="checkWeight()" [disabled]="searchOrderStop.invoiceStatus=='Prepared'"></kendo-numerictextbox>
                        </div>
                        <div class="col">
                            <select class="form-select" [(ngModel)]="editedOrderStop.weightUnitOfMeasureId" [disabled]="searchOrderStop.invoiceStatus=='Prepared'">
                                <option *ngFor="let unit of weightUnits" value="{{unit.unitOfMeasureId}}">{{unit.code}}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="editedOrderStop.eventCode == 'LUL'">
                <div class="col">
                    <label class="fw-bold">POD Name</label>
                    <input type="text" class="form-control" [(ngModel)]="editedOrderStop.podName" [disabled]="searchOrderStop.invoiceStatus=='Prepared'" />
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <label class="fw-bold">Instructions</label>
                    <textarea class="form-control" [(ngModel)]="editedOrderStop.comment" name="comment" [disabled]="searchOrderStop.invoiceStatus=='Prepared'"></textarea>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <button (click)="saveOrderStop()" class="btn btn-sm btn-primary m-2" title="Save" tabindex="-1" [disabled]="isLoading || !isStopValid || orderStopEventTypeID <= 0">Save Stop</button>
                    <button (click)="cancelEdit()" class="btn btn-sm btn-secondary m-2" title="Cancel" tabindex="-1">Cancel</button>
                </div>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="editedOrderStop&&searchOrderStop&&editedOrderStop.orderStopId>0">
        <div class="col-sm-12">
            <label class="fw-bold">References</label>
            <reference-number-grid [orderNumber]="searchOrderStop.orderNumber"
                                   [quoteOrderID]="searchOrderStop.quoteOrderID"
                                   [orderStopID]="searchOrderStop.orderStopID">
            </reference-number-grid>
        </div>
    </div>
</kendo-expansionpanel>

<div class="spinner_container dark-overlay" [ngClass]="{'dark-overlay':isLoading}" *ngIf="isLoading">
    <mat-spinner style="left: 50%; top: 50%" *ngIf="isLoading"></mat-spinner>
</div>
